export const creditImage = 'https://static.tickchak.co.il/images/app/creditImage.svg';
